import * as React from "react";
import { Container, Row, Col } from "reactstrap";
import "../../style/style.scss";
import { connect } from "react-redux";
import { StringUtil } from "../../util/stringUtil";
import { RootState } from "../../store";
import { calculateMonthlyPaymentAmount } from "../../util/calculator";

type Props = ReturnType<typeof mapStateToProps>;
const isLandingPage = document.getElementById("isLandingPage");
var classes = "text-left paymentExample";
if (isLandingPage != null) {
    classes = "text-center paymentExample landingPagePaymentExample"
}
class LoanDetails extends React.Component<Props, {}> {
  render() {
    return (
      <div className="loan-details d-flex justify-content-around">
            <div className={classes}>
          <span className="header">Lånebeløb</span>
          <span >{StringUtil.numberWithCommas(this.props.loanAmount)} kr.</span>
            </div>
            <div className="text-left paymentExample">
                <span className="header">Afdragsperiode</span>
                {this.props.loanDuration} mdr.
            </div>
           
            <div className="text-left paymentprmonth paymentExample">
                <span className="header">Betaling pr. måned</span>
                {
                    calculateMonthlyPaymentAmount(
                        this.props.loanAmount,
                        this.props.loanDuration
                    )
                }{" "}
                kr/md.
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: RootState) => ({
  loanAmount: state.applicationState.data.loanAmount,
  loanDuration: state.applicationState.data.repaymentPeriod
});

export default connect(mapStateToProps)(LoanDetails);
